export default __webpack_public_path__ + "static/media/ipdj.00620cab.png";